import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../../Entity/RequestError";
import {AssociatedProduct, Product, ProductDetailOption} from "../../Entity/Product";
import {AppThunk} from "../../../app/store";
import {getProductBySlugRep, getProductOptionsRep} from "../../Repository/ProductDetailRepository";
import {getAssociatedProductsRep} from "../../Repository/ProductRepository";

interface ProductDetailState {
  isRequesting: boolean,
  isRequestingProductsAssociated: boolean,
  isRequestSuccess: boolean,
  isRequestSuccessProductsAssociated: boolean,
  isRequestingOptions: boolean,
  isRequestOptionsSuccess: boolean,
  isRequestFailed: boolean,
  isRequestFailedProductsAssociated: boolean,
  error: RequestError | null,
  product: Product|null,
  productOptions: ProductDetailOption[]|null,
  productsAssociated: AssociatedProduct[]|null
}

const ProductDetailInitialState: ProductDetailState = {
  isRequesting: false,
  isRequestingProductsAssociated: false,
  isRequestSuccess: false,
  isRequestSuccessProductsAssociated: false,
  isRequestingOptions: false,
  isRequestOptionsSuccess: false,
  isRequestFailed: false,
  isRequestFailedProductsAssociated: false,
  product: null,
  productsAssociated: null,
  error: null,
  productOptions: null
}

function startProductDetailRequest(state: ProductDetailState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.product = null;
  state.productsAssociated = null;
}

function startProductOptionsRequest(state: ProductDetailState) {
  state.isRequestingOptions = true;
  state.isRequestFailed = false;
  state.productOptions = null;
}

function getProductOptionsRequestSuccess(state: ProductDetailState, action: PayloadAction<ProductDetailOption[]>) {
  state.isRequestingOptions = false;
  state.isRequestFailed = false;
  state.productOptions = action.payload;
}

function registerProductDetailFailed(state: ProductDetailState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerProductDetailSuccess(state: ProductDetailState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.product = action.payload as Product;
  state.productOptions = action.payload.options ?? null;
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}

function getAssociatedProductsStartRequest(state: ProductDetailState) {
  state.isRequestingProductsAssociated = true;
  state.isRequestFailedProductsAssociated = false;
  state.productsAssociated = null;
}

function getAssociatedProductsFailed(state: ProductDetailState, action: PayloadAction<any>) {
  state.isRequestingProductsAssociated = false;
  state.isRequestSuccessProductsAssociated = false;
  state.isRequestFailedProductsAssociated = true;
  state.error = action.payload;
}
function getAssociatedProductsSuccess(state: ProductDetailState, action: PayloadAction<any>) {
  state.isRequestingProductsAssociated = false;
  state.isRequestSuccessProductsAssociated = true;
  state.isRequestFailedProductsAssociated = false;
  state.error = null;
  state.productsAssociated = action.payload;
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}
const productDetailSlice = createSlice({
    name: 'productDetail',
    initialState: ProductDetailInitialState,
    reducers: {
      productDetailstartProductDetailRequest: startProductDetailRequest,
      productDetailSuccess: registerProductDetailSuccess,
      productDetailFailed: registerProductDetailFailed,
      AssociatedProductStartRequest: getAssociatedProductsStartRequest,
      AssociatedProductsSuccess: getAssociatedProductsSuccess,
      AssociatedProductsFailed: getAssociatedProductsFailed,
      startProductOptionsRequestAct: startProductOptionsRequest,
      getProductOptionsRequestSuccessAct: getProductOptionsRequestSuccess
    }
  }
)

export const {
  productDetailstartProductDetailRequest,
  productDetailSuccess,
  productDetailFailed,
  AssociatedProductStartRequest,
  AssociatedProductsSuccess,
  AssociatedProductsFailed,
  startProductOptionsRequestAct,
  getProductOptionsRequestSuccessAct
} = productDetailSlice.actions;

export default productDetailSlice.reducer;

export const getProductBySlug = (slug: string): AppThunk => async dispatch => {
  try {
    dispatch(productDetailstartProductDetailRequest());
    const newsApiResponse = await getProductBySlugRep(slug);
    dispatch(productDetailSuccess(newsApiResponse));
  } catch (err) {
    dispatch(productDetailFailed(err));
  }
}

export const getAssociatedProducts = (productCode: string, locale: string): AppThunk => async dispatch => {
  try {
    dispatch(AssociatedProductStartRequest());
    const newsApiResponse = await getAssociatedProductsRep(productCode, locale);
    dispatch(AssociatedProductsSuccess(newsApiResponse));
  } catch (err) {
    dispatch(AssociatedProductsFailed(err));
  }
}

export const getProductOptions = (productSlug: string, locale: string): AppThunk => async dispatch => {
  try {
    dispatch(startProductOptionsRequestAct());
    const newsApiResponse = await getProductOptionsRep(productSlug, locale);
    dispatch(getProductOptionsRequestSuccessAct(newsApiResponse));
  } catch (err) {
    dispatch(AssociatedProductsFailed(err));
  }
}
